<template>
    <div class="panel_container">
        <img src="@/assets/themeFour/f3.png" alt="" width="55%">
        <van-row class="btn_section">
            <van-col span="24" class="btnGroup">
                <div class="dialogBox tooltip">
                    {{ $t('home.downloadDialog') }}
                </div>

                <div v-if="iosData.display" class="download_item" @click="goToLink(iosData.redirect_url)">
                    <img :src="iosData.url" alt="" width="25%">
                    <div span="14" class="textSet">
                        <div class="applicationText">{{ $t('home.application') }}</div>
                        <div class="download_btn">{{
                            iosData.text }}</div>
                    </div>
                </div>
                <div v-if="androidData.display" span="11" class="download_item"
                    @click="goToLink(androidData.redirect_url)">
                    <img :src="androidData.url" alt="" width="25%">
                    <div span="14" class="textSet">
                        <div class="applicationText">{{ $t('home.application') }}</div>
                        <div class="download_btn" @click="goToLink(androidData.redirect_url)">{{ androidData.text }}
                        </div>
                    </div>
                </div>
            </van-col>

        </van-row>
    </div>
</template>

<script setup lang="ts">
import { goToLink } from '@/view/home/supportScript';
import { onMounted, ref } from 'vue'

const iosData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const androidData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const customStyle = ref({
    color: ""
})
const props = defineProps<{
    itemData: {
        ios: {
            url: string,
            redirect_url: string,
            display: boolean,
            text: string,
        },
        android: {
            url: string,
            redirect_url: string,
            display: boolean,
            text: string,
        },
        styles: {
            color: string
        }
    }
}>()

onMounted(() => {
    iosData.value.url = props.itemData.ios.url
    iosData.value.display = props.itemData.ios.display
    iosData.value.redirect_url = props.itemData.ios.redirect_url
    iosData.value.text = props.itemData.ios.text

    androidData.value.url = props.itemData.android.url
    androidData.value.display = props.itemData.android.display
    androidData.value.redirect_url = props.itemData.android.redirect_url
    androidData.value.text = props.itemData.android.text

    customStyle.value.color = props.itemData.styles.color
})

</script>
<style scoped>
.panel_container {
    position: relative;
    background: rgb(2, 74, 73);
    padding-top: 100px;
}


.bottom_icon img {
    position: absolute;
    right: 15px;
    top: 0;
    width: 28vw;
}

.dialogBox {
    background: rgb(0, 86, 85);
    border-radius: 5px;
    width: 52%;
    padding: 10px;
    color: #fff;
    font-size: 16px;
    margin-bottom: 15px;
}

.btnGroup {
    display: flex;
    align-items: end;
    justify-content: right;
    flex-direction: column;
}

.download_item {
    width: 45%;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    border-radius: 10px;
    margin: 5px;
    background-image: linear-gradient(90deg, rgb(0, 53, 52) 0%, rgb(0, 97, 95) 124%);
    border-top: .09375rem solid rgb(245, 200, 76);
}

.btnIcon img {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}

.textSet {
    padding: 5px;
}

.download_btn {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.4);
    font-weight: bold;
}

.applicationText {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.4);
}

@media (min-width: 450px) {
    .bottom_icon img {
        width: 150px;
    }

}

.btn_section {
    position: absolute;
    top: 0;
    left: 10px;
    right: 10px;
    z-index: 1;
}

.downloadTitle {
    background: linear-gradient(0deg, #bff1ff, #bff1ff), linear-gradient(180deg, #fff, rgba(255, 255, 255, 0));
    background-clip: border-box, border-box;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-size: 26px;
    font-weight: 800;
    box-shadow: 0 .13rem .26rem rgba(0, 0, 0, .14);
}

.downloadText {
    --tw-text-opacity: 1;
    color: rgb(137 159 190 / var(--tw-text-opacity, 1));
    font-size: 15px;
    font-weight: 600;
    padding: 25px 0;
    line-height: 25px;
}

.transfer_btn {
    color: #fff;
    font-weight: bold;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.transfer_btn img {
    width: 25px;
    padding-right: 10px;
}

.logo img {
    width: 110px;
}

.logo {
    display: flex;
    align-items: center;
    justify-content: center;
}

.bottom_section {
    position: relative;
    margin-top: -65px;
}

.tooltip {
    --s: 10px;
    /* triangle size */
    --r: 10px;
    /* the radius */

    border: var(--s) solid #0000;
    border-radius: calc(var(--r) + var(--s));
    border-bottom-left-radius: 0;
    -webkit-mask:
        radial-gradient(100% 100% at 0 0, #0000 99%, #000 102%) 0 calc(100% - var(--s))/var(--s) var(--s) no-repeat border-box,
        linear-gradient(#000 0 0) padding-box;
}

@media (max-width:400px) {
    .bottom_section {
        margin-top: -45px;
    }

    .dialogBox {
        font-size: 12px;
        padding: 5px;
        margin-bottom: 0;
    }
}
</style>